module.exports = __webpack_public_path__ + "static/media/mmu.c8e448e4.png";